import React from 'react';
//import React, { useState, useContext } from 'react';

import { render } from 'react-dom';
import App from '../src/containers/Menu/Menu';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import './custom.scss';
//import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import WebFont from 'webfontloader'; // are we using this?
//import * as serviceWorker from './serviceWorker'; // JBB - unused?
import './index.css';
import '../src/pages/responsive.css';
import { BrowserRouter, Route } from "react-router-dom";
//import { Provider } from 'react-redux' // JBB - unused?
//import configureStore from '../src/store/configureStore'; // JBB - unused?

import { UserProvider } from 'store/UserContext';

import { createBrowserHistory } from 'history'
import ReactGA from 'react-ga';


const history = createBrowserHistory();
ReactGA.initialize('UA-36825848-1');

// JBB - This should handle GA/hubspot for the history.push pattern.
//  JBB - 6/8/2020 - is this being used? not sure.
history.listen((location, action) => {
  //console.log("ROOT history.listen",document.title);
  //console.log("GA index.js",location.pathname);
  
  // JBB - 4/26/2021 - get PK user_uuid from localStorage
  let ga_set_obj = {
    page: location.pathname + location.search
  }
  const user_data_raw = window.localStorage.getItem('UserData');
  if (user_data_raw) {
    try {
      const user_data_parsed = JSON.parse(user_data_raw);
      if (user_data_parsed.login_Auth_Res) {
        if (user_data_parsed.login_Auth_Res.user_uuid) {
          ga_set_obj.userId = user_data_parsed.login_Auth_Res.user_uuid;
        }
        if (user_data_parsed.login_Auth_Res.access_level) {
          ga_set_obj.dimension1 = user_data_parsed.login_Auth_Res.access_level;
        }
        if (user_data_parsed.login_Auth_Res.account_level) {
          ga_set_obj.dimension2 = user_data_parsed.login_Auth_Res.account_level;
        }
      }
    } catch (err) {
      // don't panic
    }
  }
  setTimeout(() => {
    ReactGA.set(ga_set_obj);
    ReactGA.pageview(location.pathname + location.search);
  }, 2000);
  
  // do hubspot stuff
  if (window._hsq) {
    setTimeout(() => {
      window._hsq.push(['setPath', location.pathname]);
      window._hsq.push(['trackPageView']);
    }, 2000);
  } else {
    const script = document.createElement("script");
    script.src = "//js.hs-scripts.com/6817434.js";
    script.async = true;
    //script.onload = () => this.scriptLoaded();
    document.body.appendChild(script);
  }
    
});
//const store = configureStore(); // JBB - unused?

// JBB - This should handle GA/hubspot for NavLinks
function Analytics(props){
  console.log("ROOT Analytics",document.title);
  //console.log("GA Analytics index.js",props.location.pathname + props.location.search);
  
  // JBB - 4/26/2021 - get PK user_uuid from localStorage
  let ga_set_obj = {
    page: props.location.pathname + props.location.search
  }
  
  const user_data_raw = window.localStorage.getItem('UserData');
  if (user_data_raw) {
    try {
      const user_data_parsed = JSON.parse(user_data_raw);
      if (user_data_parsed.login_Auth_Res) {
        if (user_data_parsed.login_Auth_Res.user_uuid) {
          ga_set_obj.userId = user_data_parsed.login_Auth_Res.user_uuid;
        }
        if (user_data_parsed.login_Auth_Res.access_level) {
          ga_set_obj.dimension1 = user_data_parsed.login_Auth_Res.access_level;
        }
        if (user_data_parsed.login_Auth_Res.account_level) {
          ga_set_obj.dimension2 = user_data_parsed.login_Auth_Res.account_level;
        }
      }
      //console.log("GA",user_data_parsed,ga_set_obj);
    } catch (err) {
      // don't panic
    }
  }
  
  setTimeout(() => {
    console.log(" ROOT title",document.title);
    ReactGA.set(ga_set_obj);
    ReactGA.pageview(props.location.pathname+props.location.search);
  }, 2000);
  
  // do hubspot stuff
  if (window._hsq) {
    setTimeout(() => {
      window._hsq.push(['setPath', props.location.pathname]);
      window._hsq.push(['trackPageView']);
    }, 2000);
  } else {
    const script = document.createElement("script");
    script.src = "//js.hs-scripts.com/6817434.js";
    script.async = true;
    //script.onload = () => this.scriptLoaded();
    document.body.appendChild(script);
  }
  
  // do fluid player stuff
  if (!window.fluidPlayer) {
    const fluid_script_srcs = [
      //"/js/fluid-player-master/fluidplayer_hacked.js",
      "/js/fluid-player-master/fluidplayer_pk_20200507.min.js",
      "/js/fluid-player-master/scripts/hls.min.js",
      "/js/fluid-player-master/scripts/webvtt.min.js",
      "/js/fluid-player-master/scripts/vtt.min.js",
    ];
    for (let fluid_script_src of fluid_script_srcs) {
      const fluid_script = document.createElement("script");
      fluid_script.src = fluid_script_src;
      //fluid_script.async = true;
      fluid_script.defer = true;
      //document.body.appendChild(fluid_script);
      //console.log("LOADING FLUID PLAYER");
      document.head.appendChild(fluid_script);
    }
  }
  
  return null;
}

WebFont.load({
  google: {
    families: ['Open Sans', 'sans-serif']
  }
});

render(
  //<Provider store={store}>
    <BrowserRouter>
      <Route path="/" component={Analytics}/>
      <UserProvider>
        <App />
      </UserProvider>
    </BrowserRouter>,
  //</Provider>,
  document.getElementById('root')
)
//serviceWorker.unregister(); // JBB - unused?